import api from './utils/api';

class CitiesService {
  async listCities() {
    const result = await api.get('/cities');

    return result.data;
  }

  async listCitiesHighlights() {
    const result = await api.get('/cities/all/highlights');

    return result.data;
  }

  async listIdCities(id) {
    const result = await api.get(`/cities/${id}`);

    return result.data;
  }

  async updateHighlights(data) {
    const result = await api.put('/cities/highlights', data);
    return result.data;
  }
}

export default new CitiesService();
